import React from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "../../stylesheets/resource.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faHistory } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { Link, Redirect } from "react-router-dom";
import {
	dateCol,
	ticketPriority,
	ticketStatus,
	tableStyle,
} from "../variables/ListingVariables";
import { Department_APIs } from "./Department_APIs";
import { UserConsumer } from "../../../UserContext";
import Header from "../../timesheetModule/Header";
import { Table } from "../../../components/CustomPaginations";
import { statusColor } from "../../../components/TableStyle";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { Routes } from "../../../configurations/config";

const departmentIds = ["3", "4", "5", "6", "9"]; // departmnts to which tickets can be assigned
let token = null,
	department = null;
let empDesignation = null;
class DepartmentTicketListing extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			isLoaded: false,
			items: [],
			toggledClearRows: false,
			department: "",
			tableLoader: false,
			currentPage: 1,
			numberOfItemsPerPage: GlobalPaginationSize.defaultPaginationSize,
			pageNum: 1,
			selectedStatus: "",
			pagerData: [],
			startDate: new Date(),
			endDate: new Date(),
			sortBy: { dataField: "startDate", order: "desc" },
		};
		this.input = React.createRef();
	}
	getColumns = () => {
		return [
			{
				dataField: "ticketId",
				text: "Ticket ID",
				sort: true,
				headerStyle: {
					width: "13%",
				},
			},
			{
				dataField: "itemName",
				text: "Item Name",
				sort: true,
				formatter: (cell, row) => {
					if (row.itemName === null) {
						return row.alternateTicketItem;
					} else {
						return row.itemName;
					}
				},
				headerStyle: {
					width: "20%",
				},
			},
			{
				dataField: "creator",
				text: "Created By",
				sort: true,
				search: true,
				headerStyle: {
					width: "20%",
				},
			},

			{
				dataField: "priority",
				text: "Priority",
				formatter: ticketPriority,
			},
			{
				dataField: "status",
				text: "Status",
				formatter: ticketStatus,
				style: (cell, row) => {
					return statusColor(ticketStatus(row.status));
				},
			},
			{
				dataField: "expectedDate",
				text: "Due Date",
				sort: true,
				formatter: dateCol,
				headerStyle: {
					width: "15%",
				},
			},
			{
				dataField: "link",
				text: "Action",
				events: {
					onClick: (e) => {
						e.stopPropagation(); // To stop navigation to detail screen
					},
				},
				formatter: (cell, row) => {
					return (
						<div>
							<Link
								to={{
									pathname: `${Routes.DeptTicketApproval}/${row.ticketId}`,
									state: {
										departmentId: row.departmentId,
										currentPage: this.state.currentPage,
										redirectUrl: Routes.DeptTicketListing,
										itemStatus: ticketStatus(row.status),
									},
								}}
							>
								<FontAwesomeIcon
									title="View Detail"
									id="edit"
									className="hoverEffect"
									icon={faEye}
									size="1x"
								/>
							</Link>
							<Link
								to={{
									pathname: `${Routes.TicketHistory}/${row.ticketId}`,
									state: {
										currentPage: this.state.currentPage,
										redirectUrl: Routes.DeptTicketListing,
										projectName: row.itemName,
									},
								}}
							>
								<button className="btnStyle">
									<FontAwesomeIcon
										title="History"
										style={{
											color: "grey",
											width: "15px",
											height: "15px",
											marginLeft: "2px",
										}}
										className="hoverEffect"
										id="edit"
										icon={faHistory}
										size="1x"
									/>
								</button>
							</Link>
						</div>
					);
				},
				headerStyle: {
					width: "8%",
				},
			},
		];
	};
	componentDidMount() {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		this.setState({
			numberOfItemsPerPage: pageSize,
			items: [],
		});

		const { history } = this.props;
		history && history.replace();
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ tableLoader: true }, () => {
			axios
				.get(
					`${Department_APIs.GetDepartmentTickets_API}${department}&PageSize=${this.state.numberOfItemsPerPage}&Page=${this.state.pageNum}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					const items = res.data.ticketResponses;
					this.setState({
						items,
						tableLoader: !this.state.tableLoader,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				});
		});
	}
	SearchBar = () => {
		return (
			<div className="col-lg-3 mt-2 mb-2">
				<input
					className="form-control resourceTickets-SearchBar"
					ref={(n) => (this.input = n)}
					type="text"
					onChange={this.handleSearch}
					onFocus={() => this.setState({ currentPage: 1 })}
					placeholder="Search"
				/>
			</div>
		);
	};
	static getDerivedStateFromProps(nextProps, prevState) {
		return {
			currentPage:
				nextProps.history &&
				nextProps.history.location &&
				nextProps.history.location.state
					? nextProps.history.location.state.currentPage
					: prevState.currentPage,
		};
	}
	defaultSorted = [
		{
			dataField: "ticketId",
			order: "desc",
		},
	];
	receiveData = (PageSize) => {
		axios
			.get(
				`${
					Department_APIs.GetDepartmentTickets_API
				}${department}&PageSize=${PageSize}&Page=${1}&SortBy=${
					this.state.sortBy.dataField
				}_${this.state.sortBy.order}${
					this.input.value ? "&SearchTerm=" + this.input.value : ""
				}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					this.setState({
						pageNum: 1,
						numberOfItemsPerPage: PageSize,
						items: res.data.ticketResponses,
						pagerData: JSON.parse(res.headers["x-pagination"]),
					});
				}
			});
	};
	handleTableChange = (type, { page, sortOrder, sortField }) => {
		let getData = false;
		let apiURL = "";
		if (type === "sort") {
			let pageSize = empDesignation
				? getPaginationSizeOnRole(empDesignation)
				: this.state.numberOfItemsPerPage;
			apiURL = `${
				Department_APIs.GetDepartmentTickets_API
			}${department}&PageSize=${
				pageSize || this.state.numberOfItemsPerPage
			}&Page=${page}&SortBy=${sortField}_${sortOrder}${
				this.input.value ? "&SearchTerm=" + this.input.value : ""
			}`;
			getData = true;
			this.setState({
				sortBy: { dataField: sortField, order: sortOrder },
			});
		} else if (type === "pagination") {
			apiURL = `${
				Department_APIs.GetDepartmentTickets_API
			}${department}&PageSize=${
				this.state.numberOfItemsPerPage
			}&Page=${page}&SortBy=${sortField}_${sortOrder}${
				this.input.value ? "&SearchTerm=" + this.input.value : ""
			}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						this.setState({
							pageNum: page,
							pagerData: JSON.parse(res.headers["x-pagination"]),
							items: res.data.ticketResponses,
						});
					}
				});
		}
	};
	handleSearch = (event) => {
		const value = event.target.value;
		axios
			.get(
				`${Department_APIs.GetDepartmentTickets_API}${department}&PageSize=${this.state.numberOfItemsPerPage}&PageNumber=${this.state.pageNum}&SearchTerm=${value}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					this.setState({
						pagerData: JSON.parse(res.headers["x-pagination"]),
						items: res.data.ticketResponses,
					});
				}
			});
	};

	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					department = userDetails.department;
					token = userDetails.token;
					empDesignation = userDetails.designation;
					return userDetails.id.toString() === "79" || //kashif
						userDetails.id.toString() === "40" || //usmza
						userDetails.id.toString() === "33" || // Asif malik
						userDetails.id.toString() === "51" || //jibran
						userDetails.designation.toString() === "4" || //CM Role
						userDetails.empRole.includes("5") ||
						departmentIds.includes(
							userDetails.department.toString()
						) ||
						userDetails.empRole.includes("3") ? (
						<div className="container-fluid pl-3 pr-3">
							<Header title={"All Department Tickets"} />
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: this.state.pagerData
										? this.state.pagerData.TotalCount
										: 0,
									page: this.state.pageNum,
									sizePerPage:
										this.state.numberOfItemsPerPage,
									paginationSize:
										this.state.numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											columns={this.getColumns()}
											items={this.state.items}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												this.handleTableChange
											}
											defaultSorted={this.defaultSorted}
											tableLoader={this.state.tableLoader}
											SearchBar={this.SearchBar}
											pagerData={this.state.pagerData}
											inputValue={this.input.value}
											keyField="ticketId"
											receiveData={(PageSize) => {
												this.receiveData(PageSize);
											}}
											rowEvents={{
												onClick: (e, row) => {
													this.props.history.push({
														pathname: `${Routes.DeptTicketApproval}/${row.ticketId}`,
														state: {
															departmentId:
																row.departmentId,
															currentPage:
																this.state
																	.currentPage,
															redirectUrl:
																Routes.DeptTicketListing,
															itemStatus:
																ticketStatus(
																	row.status
																),
														},
													});
												},
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					) : (
						<Redirect to="/MyDashboard" /> //redirection
					);
				}}
			</UserConsumer>
		);
	}
}

export default DepartmentTicketListing;
